module.exports = __webpack_public_path__ + "media/images/league_placeholder-b2ce0ec6.png";